import { HubConnection } from "@aspnet/signalr";
import { EventHandler } from './event';

/**
 * A subscription to a single event type from the event relay service.
 */
export class Subscription<T> {
	private readonly connection: HubConnection;
	private readonly subscriptionId: number;
	private readonly eventMethod: string;
	private readonly leaveMethod: string;
	private readonly handler: (type: string, event: T) => void;

	constructor(
		private readonly $q: ng.IQService,
		params: {
			connection: HubConnection,
			type: string,
			subscriptionId: number,
			eventMethod: string,
			leaveMethod: string,
			handler: EventHandler<T>
	}) {
		this.connection = params.connection;
		this.subscriptionId = params.subscriptionId;
		this.eventMethod = params.eventMethod;
		this.leaveMethod = params.leaveMethod;

		this.handler = (eventType, payload) => {
			if (eventType === params.type) {
				params.handler({ type: eventType, payload });
			}
		};

		this.connection.on(params.eventMethod, this.handler);
	}

	/**
	 * Unsubscribe from the event such that if any more events from type are emitted by
	 * the event relay service, that handler passed in the constructor will not be invoked.
	 */
	unsubscribe() {
		return this.$q((resolve, reject) => {
			try
			{
				this.connection.off(this.eventMethod, this.handler);
				this.connection.send(this.leaveMethod, this.subscriptionId).then(resolve).catch(e => {
					console.warn('Failed to leave subscription group: ' + e);
					reject(e);
				});
			}
			catch (e)
			{
				console.warn('Failed to leave subscription group: ' + e);
				reject(e);
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/services/event-relay/subscription.ts